import React from 'react';
import { Bug } from 'lucide-react';
import { useAuth } from '../../utils/AuthContext';
import { useFeedback } from './FeedbackProvider';
import './FeedbackModal.css';

const FeedbackButton: React.FC = () => {
  const { user } = useAuth();
  const { open, isOpen, capturing } = useFeedback();

  if (!user || user.role === 'supplier') return null;

  return (
    <button
      type="button"
      className={`crm-feedback-btn${isOpen || capturing ? ' active' : ''}`}
      title="Report a bug or request a feature"
      aria-label="Report a bug or request a feature"
      onClick={open}
    >
      <Bug size={20} aria-hidden />
    </button>
  );
};

export default FeedbackButton;
